import { StickersSlice } from '../../prismicio-types'
import { isFilled } from '@prismicio/client'
import styles from './Stickers.module.css'

export class Stickers {
	static render(props: StickersSlice, isFixed = false) {
		const { items = [] } = props

		const data = items.map((item, {}) => {
			const speed = parseFloat(item.speed as string)
			const scale = parseFloat(item.scale as string)
			const rotation = parseFloat(item.rotation as string)
			const turns = parseFloat(item.turns as string)
			const turn_offset = parseFloat(item.turn_offset as string)
			const distance = parseFloat(item.distance as string)
			const offset = parseFloat(item.offset as string)

			return {
				image: item?.image.url,
				video: isFilled.linkToMedia(item.video) ? item.video.url : undefined,
				speed: isNaN(speed) ? 1 : speed,
				scale: isNaN(scale) ? 0.5 : scale,
				rotation: isNaN(rotation) ? 0 : rotation,
				turns: isNaN(turns) ? 0 : turns,
				turn_offset: isNaN(turn_offset) ? 0 : turn_offset,
				distance: isNaN(distance) ? 0 : distance,
				offset: isNaN(offset) ? 0 : offset
			}
		})

		return `
	<div class="${styles.Main}" 
	data-config='${JSON.stringify(data)}' 
	data-fixed="${isFixed}">
	</div>
	`
	}
}
